import { ISurveyTemplateElementGroupData } from './ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from './ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from './ISurveyTemplateUnitData';

export function isSurveyTemplateElementGroupData(
    data: ISurveyTemplateUnitData | ISurveyTemplateElementGroupData | ISurveyTemplateManifestationData,
): data is ISurveyTemplateElementGroupData {
    return (data as ISurveyTemplateElementGroupData).elementGroupName !== undefined;
}
